import Dexie from 'dexie';
let db = new Dexie('pos_trans_db');

// Define a schema
db.version(1).stores({ errors: "++id, date, time, modul, code, error"})
db.version(1).stores({ posts: "++id, sku, name, qty, price, discount, taxval, tax, user, total"})
db.open().catch((err) => { console.log(err);})

export default db;